"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConsoleLogger = void 0;
function checkFlag(key) {
    if (typeof localStorage === 'undefined') {
        return false;
    }
    return localStorage === null || localStorage === void 0 ? void 0 : localStorage[key];
}
function useConsoleLogger() {
    return checkFlag('sxp_sdk_debug');
}
exports.useConsoleLogger = useConsoleLogger;
//# sourceMappingURL=devTools.js.map